import { pick } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'js/store/hooks';

export const useIsWidgetsEnabled = () => {
    const {
        chatWidget,
        inboxWidget,
        isServerSideRendering
    } = useAppSelector(pick(['chatWidget', 'inboxWidget', 'isServerSideRendering']));
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const enableChat = chatWidget.enabled && searchParams.get('hideChat') !== '1' && !isServerSideRendering;
    const enableInbox = inboxWidget.enabled && searchParams.get('hideInbox') !== '1' && !isServerSideRendering;

    return { enableChat, enableInbox };
};
